import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const admin = props => {
    return (
        <div className={classes.TitleBox}>
            <img src="/assets/images/adminColorIcon.svg" alt="Admin" />
            <p>{applicationTitles.admin}</p>
        </div>
    );
};

export default admin;
